import { reducer as oidcReducer, UserState } from "redux-oidc";
import { AlertState } from "./AlertStore/models";
import { alertsReducer } from "./AlertStore/reducer";
import { Thermostats } from "./LegacyStore/models";
import { thermostatReducer } from "./LegacyStore/reducer";
import { LogEntry } from "./LogStore/models";
import { logReducer } from "./LogStore/reducer";
import {
  DistributorListItem,
  LoadableThermostat,
  UserAccountItem,
  UWG5NventThermostat,
} from "./UWG5NventStore/models";
import { uwg5NventReducer } from "./UWG5NventStore/reducer";
import { Category, Simulators, Workspace } from "./WorkspaceStore/models";
import { workspaceReducer } from "./WorkspaceStore/reducer";

// The top-level state object
export interface ApplicationState {
  oidc?: UserState;
  alerts: AlertState;
  logs: {
    UWG5Nvent: LogEntry[];
    NuHeat: LogEntry[];
  };
  uwg5Nvent: {
    thermostats: UWG5NventThermostat[];
    loadable: LoadableThermostat[];
    distributors: DistributorListItem[];
    users: UserAccountItem[];
  };
  legacy: {
    NuHeat: Thermostats;
  };
  workspace: {
    simulator: Simulators;
    categories: Category[];
    focused: Workspace;
  };
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  oidc: oidcReducer,
  alerts: alertsReducer,
  uwg5Nvent: uwg5NventReducer,
  legacy: thermostatReducer,
  logs: logReducer,
  workspace: workspaceReducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
  // eslint-disable-next-line no-unused-vars
  (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
